document.addEventListener('DOMContentLoaded', function() {
    let player;
    const playerElement = document.getElementById('youtube-player');
    
    if (!playerElement) {
        return;
    }
    
    const videoId = playerElement.getAttribute('data-video-id');
    const posterImage = playerElement.getAttribute('poster');
    
    if (!videoId) {
        console.error('No video ID found in data-video-id attribute');
        return;
    }

    if (posterImage) {
        playerElement.style.backgroundImage = `url(${posterImage})`;
    }

    function onYouTubeIframeAPIReady() {
        player = new YT.Player('youtube-player', {
            videoId: videoId,
            playerVars: {
                'autoplay': 1,
                'loop': 1,
                'mute': 1,
                'controls': 0,
                'playlist': videoId,
                'modestbranding': 1,
                'rel': 0,
                'playsinline': 1,
                'enablejsapi': 1,
                'iv_load_policy': 3
            },
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        });
    }

    function onPlayerReady(event) {
        event.target.playVideo();
    }

    function onPlayerStateChange(event) {
        if (event.data === YT.PlayerState.PLAYING) {
            playerElement.classList.add('video-loaded');
        }
        if (event.data === YT.PlayerState.ENDED) {
            event.target.playVideo();
        }
    }

    if (typeof YT !== 'undefined' && YT.Player) {
        onYouTubeIframeAPIReady();
    } else {
        window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
    }
});
